import { render, staticRenderFns } from "./DrawerHeader.vue?vue&type=template&id=c660b62c"
import script from "./DrawerHeader.vue?vue&type=script&lang=js"
export * from "./DrawerHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports